import { getAccountIdentifier } from 'v2/pages/settings/integrations/utils/account-identifier'
import type { RExternalOrgApp } from 'v2/types/api/settings'
import { getActionConnectionAvailability } from './integration-action-source'

interface ActionConnectionLabelProps {
  app: RExternalOrgApp
  accountInfo?: string
  aciEnabled?: boolean
}

/**
 * Lives in its own module so `integration-action-options` can stay a pure `.ts`
 * helper file. A module that exports a component AND plain helpers defeats React
 * Fast Refresh for every consumer of those helpers (react-doctor/only-export-components).
 */
export const ActionConnectionLabel = ({
  app,
  accountInfo,
  aciEnabled = false,
}: ActionConnectionLabelProps) => {
  const availability = getActionConnectionAvailability(app, aciEnabled)
  const resolvedAccountInfo = accountInfo ?? getAccountIdentifier(app)
  return (
    <div className="flex items-center gap-2">
      <span className="text-s-500">{app.name}</span>
      {resolvedAccountInfo && (
        <span className="text-xs-400 text-tertiary">({resolvedAccountInfo})</span>
      )}
      {availability.migrationLabel && (
        <span className="text-xs-500 text-status-warning">{availability.migrationLabel}</span>
      )}
    </div>
  )
}
